import script from "./BannerSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerSlider.vue?vue&type=script&setup=true&lang=js"

import "./BannerSlider.vue?vue&type=style&index=0&id=a2bc6694&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2bc6694"]])

export default __exports__